import React, { ComponentProps } from 'react'
import { SelectUi, SelectUiStylesInterface } from './ui/select-ui'

interface SelectNewProps
  extends ComponentProps<typeof SelectUi>,
    SelectUiStylesInterface {
  children: React.ReactNode
}

export const SelectNew = ({ children, ...props }: SelectNewProps) => {
  return <SelectUi {...props}>{children}</SelectUi>
}
